module.exports = __webpack_public_path__ + "img/collection-diamondJewelryColliers.b16b9dd.webp";